import React from "react";
import { FooterButtonProps, UseFooterButtonProps } from "./type";
import { useFooterButton } from "./useFooterButton";
import FooterButtonView from "./FooterButtonView";

function FooterButton(props: FooterButtonProps) {
  const hook: UseFooterButtonProps = useFooterButton(props);

  return <FooterButtonView props={props} hook={hook} />;
}
export default React.memo(FooterButton);
